export const BNBTokenAddress = "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";
export const USDTokenAddress = "0x55d398326f99059fF775485246999027B3197955";
export const PancakeSwapContractAddress = "0x10ed43c718714eb63d5aa57b78b54704e256024e";
export const PancakeRouterContractAddress = "0x10ed43c718714eb63d5aa57b78b54704e256024e";

export const AppTokenAddress = "0xd10672a959ce3bb8939827391fe78762f518f740";
export const EthRewardsTokenAddress = "0xb1b6c1717a2273a907d9778cf5318aee2e4bc67e";
export const ETHDecimals = 18;
export const EtherUnit = "ether";

export const IS_CONNECTED = "IS_CONNECTED";
export const CONNECTED_PROVIDER = "CONNECTED_PROVIDER";
